<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroBuilding" />
    <SectionProjects />
    <SectionDocuments />
    <SectionIntelligentPDF />
    <section-search />
    <!--Section :content="searchFirst" /-->   
    <section-own-your-data />
    <section-more-secure />
    <CallToAction :content="buildingCTA" />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionProjects from '@/components/section-projects.vue';
import SectionDocuments from '@/components/section-documents.vue';
import SectionIntelligentPDF from '@/components/section-intelligent-pdf.vue';
import SectionSearch from '@/components/section-search.vue';
import SectionOwnYourData from '@/components/section-own-your-data.vue';
import SectionMoreSecure from '@/components/section-more-secure.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'Building',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionProjects,
    SectionDocuments,
    SectionIntelligentPDF,
    SectionSearch,
    SectionOwnYourData,
    SectionMoreSecure,
    CallToAction,
    GmxFooter
  },
  data() {
    return { 
      heroBuilding: { 
        eyebrowIcon: 'trinity_construction.png',
        eyebrowTitle: 'Building',
        eyebrowSubtitle: 'AECO: Architecture, Engineering, Construction & Operations',
        header: 'Common Data Environment',
        subheader: 'Where the whole supply chain for the building industry can collaborate from a single source of truth to change the digital twin of a building through a project.',
        img: 'hero-intelligentPDF.png',
        videoId: '699342008',
        buttons: [
          { label: 'Projects', path: '', id: 'projects' },
          { label: 'Documents', path: '', id: 'documents' },
          { label: 'IntelligentPDF\u2122', path: '', id: 'intelligent-pdf' },
          { label: 'TrinPod\u2122', path: '', id: 'own-your-data' },
        ]
      },
      searchFirst: { 
        eyebrow: 'Search',
        eyebrowIcon: '',
        headline: 'Find the needle in the haystack',
        paragraphs: [
          'With thousands of PDF documents spread across multiple locations, finding the information you need, sometimes spread inside multiple documents, can take a very long time.',
          'TrinApp\u2122 Search inside IntelligentPDF\u2122 stored across TrinPod\u2122 enables you to pinpoint your search and quickly find the information you need. You will be able to quickly find the needle in the haystack.'
        ],
        id: 'search-first',
        image: 'crosslink-search-results-crop.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        /*html: 
          '<div>' + 
          ' <h3 class="mb-4">Find the needle in the haystack</h3>' + 
          ' <p>With thousands of PDF documents spread across multiple locations, finding the information you need, sometimes spread inside multiple documents, can take a very long time.</p>' +
          ' <p>TrinApp\u2122 Search inside IntelligentPDF\u2122 stored across TrinPod\u2122 enables you to pinpoint your search and quickly find the information you need. You will be able to quickly find the needle in the haystack.</p>' +
          '</div>'*/
      },
      buildingCTA: {
        header: 'Start using TrinPod\u2122',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
